import styled, { css } from 'styled-components';
import MarkdownText from 'ggApp/shared/common/MarkdownText';
import BannerCopyBox from './CopyBox';

const Wrap = styled.div`
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    position: relative;
    background: ${({ theme }) => theme.colors.secondaryBackground};
    min-height: 48px;
    padding: ${({ theme }) => theme.spacers.L};
    border-radius: 8px;
    ${({ theme }) => css(theme.typography.Paragraph)}
    > * {
        color: ${({ theme }) => theme.colors.secondary};
    }
    b, strong {
        font-weight: bold;
    }
`;

const Text = styled(MarkdownText)``;

const CopyBox = styled(BannerCopyBox)`
    min-width: 15%;
`;

export { Wrap, Text, CopyBox };
